export default {
  path: '/brandManagement',
  redirect: '/brandManagement/brandMgt',
  meta: {
      title: "供应商管理",
      breadcrumb: true
  },
  component: {
      name: 'brandManagement',
      template: '<router-view></router-view>'
  },
  children: [
    {
      path: 'brandMgt',
      meta: {
        title: '供应商管理',
        breadcrumb: true
      },
      component: {
        name: 'brandMgt',
        template: '<router-view></router-view>'
      },
      children: [
        {
          path: '',
          meta: {
            title: '供应商管理',
          },
          component: (resolve) => require(['@/views/plat/brandManagement/brandMgt'], resolve)
        },
      ]
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/brandManagement.js